var render = function render() {
  var _vm$accountInfo;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataForm,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品信息")))])]), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品标识"),
      prop: "mark"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("产品标识"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.dropDownSearchNo,
      disabled: true
    },
    on: {
      change: _vm.markChange
    },
    model: {
      value: _vm.dataForm.mark,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "mark", $$v);
      },
      expression: "dataForm.mark"
    }
  }, _vm._l(_vm.mainList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.mark
      }
    }, [_vm._v(_vm._s(item.mark) + "-" + _vm._s(item.name))]);
  }), 1), _c("div", {
    staticClass: "right"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("自定义名称"),
      prop: "name"
    }
  }, [_vm.$route.params.type == 1 ? _c("a-input", {
    attrs: {
      placeholder: _vm.$t("产品名称"),
      disabled: !_vm.form.name.isEdit
    },
    model: {
      value: _vm.dataForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "name", $$v);
      },
      expression: "dataForm.name"
    }
  }) : _c("a-input", {
    attrs: {
      placeholder: _vm.$t("产品名称"),
      disabled: true
    },
    model: {
      value: _vm.dataForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "name", $$v);
      },
      expression: "dataForm.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品代码")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.form.code,
      placeholder: "-",
      disabled: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备案号")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.form.recordNumber,
      placeholder: "-",
      disabled: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备案名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.recordName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "recordName", $$v);
      },
      expression: "form.recordName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保单位")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.unitName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "unitName", $$v);
      },
      expression: "form.unitName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保机构")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.agencyName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "agencyName", $$v);
      },
      expression: "form.agencyName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("中介机构")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.intermediaryName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "intermediaryName", $$v);
      },
      expression: "form.intermediaryName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品大类")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.sortName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sortName", $$v);
      },
      expression: "form.sortName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保区域")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.underwriteArea,
      callback: function ($$v) {
        _vm.$set(_vm.form, "underwriteArea", $$v);
      },
      expression: "form.underwriteArea"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("出单模式")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.form.isTimely == 1 ? _vm.$t("实时出单") : _vm.form.isTimely == 0 ? _vm.$t("非实时出单") : "",
      placeholder: "-",
      disabled: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("生效日")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.effectiveDate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "effectiveDate", $$v);
      },
      expression: "form.effectiveDate"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保份数")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.servings,
      callback: function ($$v) {
        _vm.$set(_vm.form, "servings", $$v);
      },
      expression: "form.servings"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("自动续保")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.form.isRenewal == 1 ? _vm.$t("是") : _vm.form.isRenewal == 0 ? _vm.$t("否") : "",
      placeholder: "-",
      disabled: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "contBox3",
    attrs: {
      label: _vm.$t("基础价格"),
      prop: "price"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.form.price,
      callback: function ($$v) {
        _vm.$set(_vm.form, "price", $$v);
      },
      expression: "form.price"
    }
  })], 1)], 1)], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("发布信息")))])]), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [((_vm$accountInfo = _vm.accountInfo) === null || _vm$accountInfo === void 0 ? void 0 : _vm$accountInfo.tag) != 0 ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    ref: "customer",
    attrs: {
      label: _vm.$t("发布客户"),
      prop: "customerId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("发布客户"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.dropDownSearchNo,
      disabled: true
    },
    on: {
      change: _vm.customerChange
    },
    model: {
      value: _vm.dataForm.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "customerId", $$v);
      },
      expression: "dataForm.customerId"
    }
  }, _vm._l(_vm.customerList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    ref: "applicationId",
    attrs: {
      label: _vm.$t("发布应用"),
      prop: "applicationId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("发布应用"),
      disabled: true
    },
    model: {
      value: _vm.dataForm.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "applicationId", $$v);
      },
      expression: "dataForm.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(" " + _vm._s(item.name) + "(" + _vm._s(item.type == 1 ? _vm.$t("app") : item.type == 2 ? _vm.$t("h5") : item.type == 3 ? "pc" : _vm.$t("小程序")) + ") ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("可回溯"),
      prop: "isRetraceable"
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.isRetraceable ? _vm.$t("是") : _vm.$t("否"),
      placeholder: "-",
      disabled: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保二维码"),
      prop: "isGenerateQr"
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataForm.isGenerateQr ? _vm.$t("生成") : _vm.$t("不生成"),
      placeholder: "-",
      disabled: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否可开具发票"),
      prop: "isInvoice"
    }
  }, [_c("a-radio-group", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataForm.isInvoice,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "isInvoice", $$v);
      },
      expression: "dataForm.isInvoice"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))])], 1)], 1)], 1), _vm.dataForm.isInvoice === 1 ? [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发票信息发送类型"),
      prop: "invoiceSendMethod"
    }
  }, [_c("a-radio-group", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataForm.invoiceSendMethod,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "invoiceSendMethod", $$v);
      },
      expression: "dataForm.invoiceSendMethod"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "INTERNAL"
    }
  }, [_vm._v(_vm._s(_vm.$t("内部发送")))]), _c("a-radio", {
    attrs: {
      value: "EXTERNAL"
    }
  }, [_vm._v(_vm._s(_vm.$t("外部发送")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否可作废发票"),
      prop: "isInvoiceOffset"
    }
  }, [_c("a-radio-group", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataForm.isInvoiceOffset,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "isInvoiceOffset", $$v);
      },
      expression: "dataForm.isInvoiceOffset"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))])], 1)], 1)], 1)] : _vm._e(), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分类标签")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "30%",
      "margin-right": "15px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("分类"),
      allowClear: "",
      "filter-option": _vm.dropDownSearchNo,
      disabled: _vm.$route.params.type == 2 ? true : false
    },
    on: {
      change: _vm.classificationChange
    },
    model: {
      value: _vm.dataForm.classificationId,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "classificationId", $$v);
      },
      expression: "dataForm.classificationId"
    }
  }, _vm._l(_vm.classificationList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.classificationId
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _vm.$route.params.type == 2 ? _c("a-select", {
    staticStyle: {
      width: "66%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("标签"),
      allowClear: "",
      "filter-option": _vm.dropDownSearchNo,
      disabled: true,
      mode: "multiple"
    },
    model: {
      value: _vm.labelIds,
      callback: function ($$v) {
        _vm.labelIds = $$v;
      },
      expression: "labelIds"
    }
  }, _vm._l(_vm.labelList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: String(item.labelId)
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1) : _c("a-select", {
    staticStyle: {
      width: "66%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("标签"),
      allowClear: "",
      "filter-option": _vm.dropDownSearchNo,
      disabled: !_vm.dataForm.classificationId ? true : false,
      mode: "multiple"
    },
    model: {
      value: _vm.labelIds,
      callback: function ($$v) {
        _vm.labelIds = $$v;
      },
      expression: "labelIds"
    }
  }, _vm._l(_vm.labelList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: String(item.labelId)
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "declarationMethod"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("申报方式")) + "  "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("目前只有走“雇主责任险”的险种需要配置")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-radio-group", {
    model: {
      value: _vm.dataForm.declarationMethod,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "declarationMethod", $$v);
      },
      expression: "dataForm.declarationMethod"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "DAY",
      disabled: ""
    }
  }, [_vm._v(_vm._s(_vm.$t("日申报")))]), _c("a-radio", {
    attrs: {
      value: "MONTH",
      disabled: ""
    }
  }, [_vm._v(_vm._s(_vm.$t("月申报")))])], 1)], 1)], 1)], 2), _vm.dataForm.mark && _vm.dataForm.customerId ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("支付信息")))])]) : _vm._e(), _vm.dataForm.mark && _vm.dataForm.customerId ? _c("div", [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付方式"),
      prop: "paymentMethods"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("支付方式"),
      disabled: _vm.customerInsuranceId == -1 ? false : true
    },
    on: {
      change: _vm.payWayChange
    },
    model: {
      value: _vm.dataForm.paymentMethods.payWay,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm.paymentMethods, "payWay", $$v);
      },
      expression: "dataForm.paymentMethods.payWay"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("保司链接支付")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("三方支付")))]), _c("a-select-option", {
    attrs: {
      value: 4
    }
  }, [_vm._v(_vm._s(_vm.$t("授信支付")))]), _c("a-select-option", {
    attrs: {
      value: 5
    }
  }, [_vm._v(_vm._s(_vm.$t("易宝支付")))])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.dataForm.mark && _vm.form.reminder ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保提醒")))])]) : _vm._e(), _vm.dataForm.mark ? _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保提醒"),
      labelCol: {
        span: 2,
        offset: 0
      }
    }
  }, [_c("div", {
    staticStyle: {
      border: "1px solid #d9d9d9",
      "border-radius": "4px",
      padding: "0 10px",
      "min-height": "32px"
    },
    domProps: {
      innerHTML: _vm._s(_vm.addKeyWordHighline(_vm.form.reminder.content || "", _vm.form.reminder.list || ""))
    }
  })])], 1)], 1) : _vm._e()], 1), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1), _vm.intermediariesShow ? _c("intermediaries-model", {
    ref: "intermediariesRef",
    on: {
      cancel: function ($event) {
        _vm.intermediariesShow = false;
      },
      ok: _vm.getAccount
    }
  }) : _vm._e(), _vm.eproShow ? _c("epro-model", {
    ref: "eproRef",
    on: {
      cancel: function ($event) {
        _vm.eproShow = false;
      },
      ok: _vm.getAccount
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };